// eslint-disable-next-line no-restricted-imports
import { Select } from 'foundations-components/transitional/components/Select';
import { localeI18nText } from '../utils/localeI18nText';
import useLocaleContext from '../hooks/useLocaleContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const LocalizedSelect = props => {
  const {
    locale
  } = useLocaleContext();
  return /*#__PURE__*/_jsx(Select, Object.assign({
    placeholder: localeI18nText('app.selectComponents.placeholder', locale),
    searchPlaceholder: localeI18nText('app.selectComponents.searchPlaceholder', locale),
    noResultsText: localeI18nText('app.selectComponents.noResults', locale)
  }, props));
};